export const PREFIX_AUT_ID = 'ulLevel_';
export const MAX_ITEMS_SHOW = 5;
